import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import LoadingSpinner from '../partials/LoadingSpinner';
import PageHeader from '../partials/PageHeader';
import { Link, useParams, useNavigate } from "react-router-dom";


import { editSupplier } from '../../redux/actions/suppliers';
import { taxSettingsIndex } from '../../redux/actions/taxSettings';
import { paymentTermsIndex } from '../../redux/actions/paymentTerms';
import { paymentMethodsIndex } from '../../redux/actions/paymentMethods';

const EditSupplierForm = ({ payload, newSupplier, updateSupplier, loadTaxSettings, loadPaymentTerms, loadPaymentMethods, taxSettings, paymentTerms, paymentMethods, suppliers }) => {
  let navigate = useNavigate();

  const [submitted, setSubmitted] = useState(false);

  const { id } = useParams();

  const [validAddress, setValidAddress] = useState(false);  
  const [validSupplier, setValidSupplier] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);

  const [supplierName, setSupplierName] = useState(suppliers.find(supplier => supplier.id === id).supplier_name);
  const [contactEmail, setContactEmail] = useState(suppliers.find(supplier => supplier.id === id).contact_email);
  const [contactPhone, setContactPhone] = useState(suppliers.find(supplier => supplier.id === id).contact_phone);
  const [accountNumber, setAccountNumber] = useState(suppliers.find(supplier => supplier.id === id).account_number);
  const [phoneTollFree, setPhoneTollFree] = useState(suppliers.find(supplier => supplier.id === id).phone_toll_free);
  const [fax, setFax] = useState(suppliers.find(supplier => supplier.id === id).fax);
  const [websiteAddress, setWebsiteAddress] = useState(suppliers.find(supplier => supplier.id === id).website_address);
  const [orderPortal, setOrderPortal] = useState(suppliers.find(supplier => supplier.id === id).order_portal);
  const [supplierNotes, setSupplierNotes] = useState(suppliers.find(supplier => supplier.id === id).supplier_notes);
  const [shippingDays, setShippingDays] = useState(suppliers.find(supplier => supplier.id === id).shipping_days);

  const [taxSetting, setTaxSetting] = useState(suppliers.find(supplier => supplier.id === id).tax_setting_id);
  const [paymentTerm, setPaymentTerm] = useState(suppliers.find(supplier => supplier.id === id).payment_terms_id);
  const [paymentMethod, setPaymentMethod] = useState(suppliers.find(supplier => supplier.id === id).payment_method_id);

  const [firstName, setFirstName] = useState(suppliers.find(supplier => supplier.id === id).address.first_name);
  const [lastName, setLastName] = useState(suppliers.find(supplier => supplier.id === id).address.last_name);
  const [company, setCompany] = useState(suppliers.find(supplier => supplier.id === id).address.company);
  const [street1, setStreet1] = useState(suppliers.find(supplier => supplier.id === id).address.street_1);
  const [street2, setStreet2] = useState(suppliers.find(supplier => supplier.id === id).address.street_2);
  const [city, setCity] = useState(suppliers.find(supplier => supplier.id === id).address.city);
  const [zip, setZip] = useState(suppliers.find(supplier => supplier.id === id).address.zip);
  const [country, setCountry] = useState(suppliers.find(supplier => supplier.id === id).address.country);
  const [state, setState] = useState(suppliers.find(supplier => supplier.id === id).address.state);


  useEffect(() => {
    loadTaxSettings(payload);
    loadPaymentTerms(payload);
    loadPaymentMethods(payload);
  }, []);

  useEffect(() => {
    if(newSupplier) { navigate(-1) };
  }, [newSupplier]);

  useEffect(() => {
    console.log(taxSettings)
    console.log(taxSetting)

    if(taxSetting && typeof taxSetting === 'string' && taxSettings.taxSettings.length > 0) {
      setTaxSetting(taxSettings.taxSettings.find(setting => setting.id === taxSetting));
    }
  }, [taxSettings]);

  useEffect(() => {
    console.log(paymentTerms)
    console.log(paymentTerm)

    if(paymentTerm && typeof paymentTerm === 'string' && paymentTerms.paymentTerms.length > 0) {
      setPaymentTerm(paymentTerms.paymentTerms.find(term => term.id === paymentTerm));
    }
  }, [paymentTerms]);

  useEffect(() => {
    console.log(paymentMethods)
    console.log(paymentMethod)

    if(paymentMethod && typeof paymentMethod === 'string' && paymentMethods.paymentMethods.length > 0) {
      setPaymentMethod(paymentMethods.paymentMethods.find(method => method.id === paymentMethod));
    }
  }, [paymentMethods]);

  const addressJson = () => {
    return {
      'id': suppliers.find(supplier => supplier.id === id).address_id,
      'first_name': firstName,
      'last_name': lastName,
      'company': company,
      'street_1': street1,
      'street_2': street2,
      'city': city,
      'zip': zip,
      'country': country,
      'state': state
    }
  }

  const supplierJson = () => {
    return {
      'id': id,
      'supplier_name': supplierName,
      'contact_email': contactEmail,
      'contact_phone': contactPhone,
      'account_number': accountNumber,
      'phone_toll_free': phoneTollFree,
      'fax': fax,
      'website_address': websiteAddress,
      'order_portal': orderPortal,
      'supplier_notes': supplierNotes,
      'shipping_days': shippingDays,
      'tax_setting_id': taxSetting?.id,
      'payment_terms_id': paymentTerm?.id,
      'payment_method_id': paymentMethod?.id
    }
  }

  const validateAddress = () => {
    setValidAddress((firstName.length > 0) && (lastName.length > 0) && (street1.length > 0) && (city.length > 0) && (zip.length > 0) && (country.length > 0) && (state.length > 0));
  }

  const validateSupplier = () => {
    setValidSupplier(supplierName.length > 0);
  }

  const setFieldValue = (event, setField) => {
    let value = event.target.value;

    if (value) {
      event.target.parentElement.classList.add("field--filled");
    } else {
      event.target.parentElement.classList.remove("field--filled");
    }

    setField(value);
    validateSupplier();
  }

  const setDropdownValue = (value, setField) => {
    setField(value);
    validateSupplier();
  }

  const setAddressValue = (event, setField) => {
    let value = event.target.value;

    if (value) {
      event.target.parentElement.classList.add("field--filled");
    } else {
      event.target.parentElement.classList.remove("field--filled");
    }

    setField(value);
    validateAddress();
  }

  const focus = (event) => {
    event.target.parentElement.classList.add("field--focus");
  }

  const blur = (event) => {
    event.target.parentElement.classList.remove("field--focus");
  }



  const handleSubmit = () => {
    setSubmitted(true);
    updateSupplier(payload, supplierJson(), addressJson());
  }

  return(
    <>
      <PageHeader stripeBackground='#fbe194' helpLink="ecwid/manage-suppliers-2/" />
      <div className="settings-page cf">
        <div className="settings-page__header">

          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title">New Supplier</div>
              </div>
              <div className="named-area__description">
                <p>Fill out fields to update this supplier.</p>
                <p>Select default tax settings, payment terms and payment method from their respective dropdowns. If tax settings, payment terms or payment methods are missing, go to the <Link to="/settings">Settings page</Link> to update those options.</p>
                <p>Once the supplier's information has been updated, click the "Update Supplier" button to submit this form and update the supplier.</p>
              </div>
            </div>
            <div className="named-area__body">
              <div className="a-card-stack">
                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">
                    <div className="fieldset">

                      <div className="field field--medium field--filled">
                        <span className="fieldset__svg-icon"></span>
                        <label className="field__label">Supplier Name</label>
                        <input type="text" value={supplierName} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(e, setSupplierName)} className="field__input" tabindex="4" maxlength="64" />
                        <div className="field__placeholder">Supplier Name</div>
                      </div>

                      <div className="field field--medium field--filled">
                        <span className="fieldset__svg-icon"></span>
                        <label className="field__label">Contact Email</label>
                        <input type="text" value={contactEmail} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(e, setContactEmail)} className="field__input" tabindex="4" maxlength="64" />
                        <div className="field__placeholder">Contact Email</div>
                      </div>

                      <div className="field field--medium field--filled">
                        <span className="fieldset__svg-icon"></span>
                        <label className="field__label">Contact Phone</label>
                        <input type="text" value={contactPhone} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(e, setContactPhone)} className="field__input" tabindex="4" maxlength="64" />
                        <div className="field__placeholder">Contact Phone</div>
                      </div>


                      <div className="field field--medium field--filled">
                        <span className="fieldset__svg-icon"></span>
                        <label className="field__label">Account Number</label>
                        <input type="text" value={accountNumber} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(e, setAccountNumber)} className="field__input" tabindex="4" maxlength="64" />
                        <div className="field__placeholder">Account Number</div>
                      </div>

                      <div className="field field--medium field--filled">
                        <span className="fieldset__svg-icon"></span>
                        <label className="field__label">Phone Toll Free</label>
                        <input type="text" value={phoneTollFree} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(e, setPhoneTollFree)} className="field__input" tabindex="4" maxlength="64" />
                        <div className="field__placeholder">Phone Toll Free</div>
                      </div>

                      <div className="field field--medium field--filled">
                        <span className="fieldset__svg-icon"></span>
                        <label className="field__label">Fax</label>
                        <input type="text" value={fax} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(e, setFax)} className="field__input" tabindex="4" maxlength="64" />
                        <div className="field__placeholder">Fax</div>
                      </div>

                      <div className="field field--medium field--filled">
                        <span className="fieldset__svg-icon"></span>
                        <label className="field__label">Website Address</label>
                        <input type="text" value={websiteAddress} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(e, setWebsiteAddress)} className="field__input" tabindex="4" maxlength="64" />
                        <div className="field__placeholder">Website Address</div>
                      </div>

                      <div className="field field--medium field--filled">
                        <span className="fieldset__svg-icon"></span>
                        <label className="field__label">Order Portal</label>
                        <input type="text" value={orderPortal} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(e, setOrderPortal)} className="field__input" tabindex="4" maxlength="64" />
                        <div className="field__placeholder">Order Portal</div>
                      </div>

                      <div className="field field--medium field--filled">
                        <span className="fieldset__svg-icon"></span>
                        <label className="field__label">Supplier Notes</label>
                        <input type="text" value={supplierNotes} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(e, setSupplierNotes)} className="field__input" tabindex="4" maxlength="64" />
                        <div className="field__placeholder">Supplier Notes</div>
                      </div>

                      <div className="field field--medium field--filled">
                        <span className="fieldset__svg-icon"></span>
                        <label className="field__label">Shipping Days</label>
                        <input type="text" value={shippingDays} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(e, setShippingDays)} className="field__input" tabindex="4" maxlength="64" />
                        <div className="field__placeholder">Shipping Days</div>
                      </div>


                    </div>


                  </div>    
                </div>

              </div>
            </div>
          </div>


          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title">Supplier Payment and Taxes</div>
              </div>
              <div className="named-area__description">
                

              </div>
            </div>
            <div className="named-area__body">
              <div className="a-card-stack">
                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">
                    <div className="flex-container">

                      <div className="flex-1">
                        {taxSettings.status === 'success' && taxSettings.taxSettings.length > 0 &&
                          <div className="fieldset fieldset--select">
                            <div className="field field--medium field--filled field--filled">
                              <label className="field__label">Default Tax Setting</label>
                              <select onChange={(e) => setTaxSetting(e.target.value)} className="field__select">
                                <option hidden disabled selected={taxSetting === null} value></option>
                                { taxSettings.taxSettings.map((optionItem) =>
                                  <option selected={taxSetting === optionItem.id} value={optionItem.id} key={optionItem.id}>{optionItem.tax_name}</option>
                                )}
                              </select>

                              <div className="field__placeholder">Default Tax Setting</div>
                            </div>
                          </div>
                        }
                        { taxSettings.status !== 'success' &&
                          <LoadingSpinner size="xxSmall" statusText="Loading tax settings" />
                        }
                        { taxSettings.status === 'success' && taxSettings.taxSettings.length === 0 &&
                          <div className="a-card a-card--vertical-compact a-card--info a-card--info-blue">
                            <div className="a-card__paddings">
                              <p>No tax settings set. Create tax settings to see them in a dropdown here.</p>
                              <Link to="/settings">
                                <button className="btn btn-primary-accent btn-medium">Update Settings</button>
                              </Link>
                            </div>
                          </div>
                        }
                      </div>

                      <div className="flex-1">
                        { paymentTerms.status === 'success' && paymentTerms.paymentTerms.length > 0 &&
                          <div className="fieldset fieldset--select">
                            <div className="field field--medium field--filled field--filled">
                              <label className="field__label">Default Payment Term</label>
                              <select onChange={(e) => setPaymentTerm(e.target.value)} className="field__select">
                                <option hidden disabled selected={paymentTerm === null} value></option>
                                { paymentTerms.paymentTerms.map((optionItem) =>
                                  <option selected={paymentTerm === optionItem.id} value={optionItem.id} key={optionItem.id}>{optionItem.term_name}</option>
                                )}
                              </select>

                              <div className="field__placeholder">Default Payment Term</div>
                            </div>
                          </div>
                        }
                        { paymentTerms.status !== 'success' &&
                          <LoadingSpinner size="xxSmall" statusText="Loading payment terms" />
                        }
                        { paymentTerms.status === 'success' && paymentTerms.paymentTerms.length === 0 &&
                          <div className="a-card a-card--vertical-compact a-card--info a-card--info-blue left-15">
                            <div className="a-card__paddings">
                              <p>No payment terms set. Create payment terms to see them in a dropdown here.</p>
                              <Link to="/settings">
                                <button className="btn btn-primary-accent btn-medium">Update Settings</button>
                              </Link>
                            </div>
                          </div>
                        }
                      </div>

                      <div className="flex-1">
                        { paymentMethods.status === 'success' && paymentMethods.paymentMethods.length > 0 &&
                          <div className="fieldset fieldset--select">
                            <div className="field field--medium field--filled field--filled">
                              <label className="field__label">Default Payment Method</label>
                              <select onChange={(e) => setPaymentMethod(e.target.value)} className="field__select">
                                <option hidden disabled selected={paymentMethod === null} value></option>
                                { paymentMethods.paymentMethods.map((optionItem) =>
                                  <option selected={paymentMethod === optionItem.id} value={optionItem.id} key={optionItem.id}>{optionItem.method_name}</option>
                                )}
                              </select>

                              <div className="field__placeholder">Default Payment Method</div>
                            </div>
                          </div>
                        }
                        { paymentMethods.status !== 'success' &&
                          <LoadingSpinner size="xxSmall" statusText="Loading payment methods" />
                        }
                        { paymentMethods.status === 'success' && paymentMethods.paymentMethods.length === 0 &&
                          <div className="a-card a-card--vertical-compact a-card--info a-card--info-blue left-15">
                            <div className="a-card__paddings">
                              <p>No payment methods set. Create payment methods to see them in a dropdown here.</p>
                              <Link to="/settings">
                                <button className="btn btn-primary-accent btn-medium">Update Settings</button>
                              </Link>
                            </div>
                          </div>
                        }
                      </div>

                    </div>
                  </div>    
                </div>

              </div>
            </div>
          </div>


          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title">Supplier Address Details</div>
              </div>
              <div className="named-area__description">
                
              </div>
            </div>
            <div className="named-area__body">
              <div className="a-card-stack">
                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">
                    <div className="fieldset">
                      <div className="field field--medium field--filled">
                        <span className="fieldset__svg-icon"></span>
                        <label className="field__label">First Name</label>
                        <input type="text" value={firstName} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(e, setFirstName)} className="field__input" tabindex="4" maxlength="64" />
                        <div className="field__placeholder">First Name</div>
                      </div>

                      <div className="field field--medium field--filled">
                        <span className="fieldset__svg-icon"></span>
                        <label className="field__label">Last Name</label>
                        <input type="text" value={lastName} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(e, setLastName)} className="field__input" tabindex="4" maxlength="64" />
                        <div className="field__placeholder">Last Name</div>
                      </div>

                      <div className="field field--medium field--filled">
                        <span className="fieldset__svg-icon"></span>
                        <label className="field__label">Company</label>
                        <input type="text" value={company} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(e, setCompany)} className="field__input" tabindex="4" maxlength="64" />
                        <div className="field__placeholder">Company</div>
                      </div>


                      <div className="field field--medium field--filled">
                        <span className="fieldset__svg-icon"></span>
                        <label className="field__label">Street 1</label>
                        <input type="text" value={street1} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(e, setStreet1)} className="field__input" tabindex="4" maxlength="64" />
                        <div className="field__placeholder">Street 1</div>
                      </div>

                      <div className="field field--medium field--filled">
                        <span className="fieldset__svg-icon"></span>
                        <label className="field__label">Street 2</label>
                        <input type="text" value={street2} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(e, setStreet2)} className="field__input" tabindex="4" maxlength="64" />
                        <div className="field__placeholder">Street 2</div>
                      </div>

                      <div className="field field--medium field--filled">
                        <span className="fieldset__svg-icon"></span>
                        <label className="field__label">City</label>
                        <input type="text" value={city} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(e, setCity)} className="field__input" tabindex="4" maxlength="64" />
                        <div className="field__placeholder">City</div>
                      </div>

                      <div className="field field--medium field--filled">
                        <span className="fieldset__svg-icon"></span>
                        <label className="field__label">State/Province</label>
                        <input type="text" value={state} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(e, setState)} className="field__input" tabindex="4" maxlength="64" />
                        <div className="field__placeholder">State/Province</div>
                      </div>

                      <div className="field field--medium field--filled">
                        <span className="fieldset__svg-icon"></span>
                        <label className="field__label">Country</label>
                        <input type="text" value={country} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(e, setCountry)} className="field__input" tabindex="4" maxlength="64" />
                        <div className="field__placeholder">Country</div>
                      </div>

                      <div className="field field--medium field--filled">
                        <span className="fieldset__svg-icon"></span>
                        <label className="field__label">Zip/Postal Code</label>
                        <input type="text" value={zip} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(e, setZip)} className="field__input" tabindex="4" maxlength="64" />
                        <div className="field__placeholder">Zip/Postal Code</div>
                      </div>
                    </div>
                  </div>    
                </div>

              </div>
            </div>
          </div>

          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title"></div>
              </div>
              <div className="named-area__description">
                
              </div>
            </div>
            <div className="named-area__body">
              <div className="a-card-stack">
                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">
                    <button 
                      className="bottom-5 btn btn-primary btn-medium" 
                      onClick={() => handleSubmit()}
                      disabled={!((firstName.length > 0) && (lastName.length > 0) && (street1.length > 0) && (city.length > 0) && (zip.length > 0) && (country.length > 0) && (state.length > 0)) || !(supplierName.length > 0) || submitted}
                    >
                      Update Supplier
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </>
  )
}

const mapStateToProps = state => ({
  newSupplier: state.suppliers.newSupplier,
  taxSettings: state.taxSettings,
  paymentTerms: state.paymentTerms,
  paymentMethods: state.paymentMethods,
  suppliers: state.suppliers.suppliers,
});

const mapDispatchToProps = (dispatch) => ({
  updateSupplier: (payload, supplier, address) => dispatch(editSupplier(payload, supplier, address)),
  loadTaxSettings: (payload) => dispatch(taxSettingsIndex(payload)),
  loadPaymentTerms: (payload) => dispatch(paymentTermsIndex(payload)),
  loadPaymentMethods: (payload) => dispatch(paymentMethodsIndex(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditSupplierForm);